// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"66861057","678":"82cb8259","787":"23dc1bc6"}[chunkId] + ".chunk.js";
};